import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99851988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/service_more.svg" }, null, -1))
const _hoisted_3 = { class: "detail-order-statusbox" }
const _hoisted_4 = { class: "detail-order-status" }
const _hoisted_5 = {
  key: 0,
  class: "detail-net-message"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "维修方案", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "repair-order-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/images/icon_weixiu.svg" })
], -1))
const _hoisted_9 = { class: "repair-desc" }
const _hoisted_10 = { class: "repair-desc-text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "维修单", -1))
const _hoisted_12 = {
  class: "repair-btn",
  style: {"color":"#fff","background":"#00b359"}
}
const _hoisted_13 = { class: "repair-ordernum" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "repair-order-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/images/icon_weixiu.svg" })
], -1))
const _hoisted_16 = { class: "repair-desc" }
const _hoisted_17 = { class: "repair-desc-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备用机单", -1))
const _hoisted_19 = {
  class: "repair-btn",
  style: {"color":"#fff","background":"rgba(0, 0, 0, 0.22)"}
}
const _hoisted_20 = { class: "repair-ordernum" }
const _hoisted_21 = {
  key: 1,
  class: "detail-net-message"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "定责审核", -1))
const _hoisted_23 = { class: "dingze-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "初步定责结果", -1))
const _hoisted_25 = { class: "dingze-item-value" }
const _hoisted_26 = { class: "dingze-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "检测情况", -1))
const _hoisted_28 = { class: "dingze-item-value" }
const _hoisted_29 = { class: "dingze-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "检测情况附图", -1))
const _hoisted_31 = { class: "dingze-item-imagelist" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "dingze-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "初步定责结果", -1))
const _hoisted_35 = { class: "dingze-item-value" }
const _hoisted_36 = { class: "dingze-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "分析结论", -1))
const _hoisted_38 = { class: "dingze-item-value" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "分析报告", -1))
const _hoisted_40 = { class: "dingze-item last-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dingze-item-title" }, "分析时间", -1))
const _hoisted_42 = { class: "dingze-item-value" }
const _hoisted_43 = {
  key: 2,
  class: "dingze-operate"
}
const _hoisted_44 = {
  key: 2,
  class: "detail-net-message"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "全保审核", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quanbao-message" }, " 若维修属于非质保情况，“全保审核通过”表示维修可以使用全保/延保服务额度抵扣维修费用，“全保审核不通过”表示客户需付费进行维修。 ", -1))
const _hoisted_47 = { class: "detail-net-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "审核结果", -1))
const _hoisted_49 = { class: "net-item-value" }
const _hoisted_50 = { class: "detail-net-item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "审核时间", -1))
const _hoisted_52 = { class: "net-item-value" }
const _hoisted_53 = { class: "detail-net-item last-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "审核意见", -1))
const _hoisted_55 = { class: "net-item-value" }
const _hoisted_56 = {
  key: 0,
  class: "dingze-operate"
}
const _hoisted_57 = { class: "detail-net-message" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "网点信息", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "维修网点", -1))
const _hoisted_60 = { class: "net-item-value" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "收货网点", -1))
const _hoisted_62 = { class: "net-item-value" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warning-tips" }, "温馨提醒：维修期间，请保持电话畅通", -1))
const _hoisted_64 = { class: "net-operate-box" }
const _hoisted_65 = { class: "detail-net-message" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "收件信息", -1))
const _hoisted_67 = { class: "recive-msg-item" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recive-item-title" }, "收件信息", -1))
const _hoisted_69 = {
  key: 0,
  class: ""
}
const _hoisted_70 = { class: "recive-item-value" }
const _hoisted_71 = { class: "recive-item-value" }
const _hoisted_72 = {
  key: 1,
  class: "recive-item-value"
}
const _hoisted_73 = { class: "detail-net-message detail-repair-box" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "报修设备", -1))
const _hoisted_75 = { class: "detail-repair-device" }
const _hoisted_76 = { class: "detail-repair-desc" }
const _hoisted_77 = { class: "repair-desc-first" }
const _hoisted_78 = { class: "repair-desc-second" }
const _hoisted_79 = { class: "repair-desc-second" }
const _hoisted_80 = { class: "detail-net-message detail-repair-box" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-net-title" }, "基础信息", -1))
const _hoisted_82 = { class: "detail-net-item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "服务单号", -1))
const _hoisted_84 = { class: "net-item-value" }
const _hoisted_85 = { class: "detail-net-item" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "提单时间", -1))
const _hoisted_87 = { class: "net-item-value" }
const _hoisted_88 = { class: "detail-net-item base-message" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "net-item-title" }, "提单内容", -1))
const _hoisted_90 = {
  key: 0,
  class: "xag-flex-lr header"
}
const _hoisted_91 = {
  key: 2,
  class: "comment-popup xag-flex-vertical"
}
const _hoisted_92 = { class: "xag-flex-1 content xag-flex-vertical" }
const _hoisted_93 = { class: "text-area-box xag-flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_PopupHeader = _resolveComponent("PopupHeader")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_ServiceOrderEvaluation = _resolveComponent("ServiceOrderEvaluation")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "detail-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_ctx.pagePaddingTop)}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, {
        title: "服务单",
        isReturnLeftEvent: true,
        onLeftClick: _ctx.handleClikBack,
        rightUseSlot: true,
        rightCanClick: _ctx.deviceMsg.status == 'WAIT_RECEIVE',
        onRightClick: _ctx.handleCancelService
      }, _createSlots({ _: 2 }, [
        (_ctx.deviceMsg.status == 'WAIT_RECEIVE')
          ? {
              name: "right",
              fn: _withCtx(() => [
                _hoisted_2
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["onLeftClick", "rightCanClick", "onRightClick"])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.loading) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.deviceMsg.status_text), 1),
            (_ctx.deviceMsg.concrete_status == 'WAIT_EVALUATE')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "evaluate-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleEvaluate && _ctx.handleEvaluate(...args)))
                }, " 评价 "))
              : _createCommentVNode("", true),
            (_ctx.deviceMsg.concrete_status == 'END')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "evaluate-btn white-bg",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChekEvaluate && _ctx.handleChekEvaluate(...args)))
                }, " 已评价 "))
              : _createCommentVNode("", true)
          ])
        ]),
        (
          (_ctx.repairList && _ctx.repairList.length >= 1) || (_ctx.standbyMachine && _ctx.standbyMachine.length >= 1)
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repairList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "repair-order-item",
                  key: index,
                  onClick: ($event: any) => (_ctx.handleRepairOrder(item))
                }, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("button", _hoisted_12, _toDisplayString(item.status_text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.repair_sn) + " | " + _toDisplayString(item.repair_warehouse_name), 1)
                  ]),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    size: "16",
                    class: "repair-icon"
                  })
                ], 8, _hoisted_7))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standbyMachine, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass({
            'repair-order-item': true,
            'last-item': index == _ctx.standbyMachine.length - 1 ? true : false,
          }),
                  onClick: ($event: any) => (_ctx.handleReserveOrder(item)),
                  key: index
                }, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("button", _hoisted_19, _toDisplayString(item.status_text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(item.sn) + " | " + _toDisplayString(item.warehouse_name), 1)
                  ]),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    size: "16",
                    class: "repair-icon"
                  })
                ], 10, _hoisted_14))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.responsibility && _ctx.responsibility.guid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              (_ctx.responsibility.type == 'SIMPLE')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.responsibility.responsibility_type_text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.responsibility.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responsibility.imageList, (item, index) => {
                          return (_openBlock(), _createElementBlock("img", {
                            class: "dingze-item-imageitem",
                            src: item.url,
                            key: index
                          }, null, 8, _hoisted_32))
                        }), 128))
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.responsibility.type == 'TECH')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.responsibility.responsibility_type_text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.responsibility.description), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "dingze-item",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleReporterPage && _ctx.handleReporterPage(...args)))
                    }, [
                      _hoisted_39,
                      _createElementVNode("span", {
                        class: "net-item-value",
                        style: {"color":"#00b359","font-weight":"bold"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCheckOrder && _ctx.handleCheckOrder(...args)))
                      }, "查看"),
                      _createVNode(_component_van_icon, {
                        name: "arrow net-item-icon",
                        color: "#00B359",
                        style: {"font-weight":"bold"},
                        size: "16"
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.responsibility.analysis_at), 1)
              ]),
              (_ctx.responsibility.can_client_appeal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    (_ctx.responsibility.type !== 'SIMPLE')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "dingze-operate-ssbtn",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleAppealResponsiblityPage && _ctx.handleAppealResponsiblityPage(...args)))
                        }, " 我要申诉 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "dingze-operate-btn",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleApproveReview && _ctx.handleApproveReview(...args)))
                    }, "确认审核结果")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.qualitative && _ctx.qualitative.guid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _hoisted_45,
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.qualitative.status_text), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.qualitative.verified_at), 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.qualitative.description), 1)
              ]),
              (_ctx.qualitative.can_appeal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("button", {
                      class: "dingze-operate-ssbtn",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleAppealPage && _ctx.handleAppealPage(...args)))
                    }, "我要申诉"),
                    _createElementVNode("button", {
                      class: "dingze-operate-btn",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleApproveAllProtect && _ctx.handleApproveAllProtect(...args)))
                    }, "确认审核结果")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("div", {
            class: "detail-net-item",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleRepairWare && _ctx.handleRepairWare(...args)))
          }, [
            _hoisted_59,
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.networkMsg.repairName), 1),
            _createVNode(_component_van_icon, {
              name: "arrow net-item-icon",
              size: "16",
              color: "rgba(0,0,0,0.44)"
            })
          ]),
          _createElementVNode("div", {
            class: "detail-net-item",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleReciveWare && _ctx.handleReciveWare(...args)))
          }, [
            _hoisted_61,
            _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.networkMsg.reciveName), 1),
            _createVNode(_component_van_icon, {
              name: "arrow net-item-icon",
              size: "16",
              color: "rgba(0,0,0,0.44)"
            })
          ]),
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", {
              class: "net-operate-btn",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleCallRepair && _ctx.handleCallRepair(...args)))
            }, "联系维修网点"),
            (_ctx.deviceMsg.status == 'WAIT_RECEIVE')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "net-operate-btn",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleChangeService && _ctx.handleChangeService(...args)))
                }, " 更改维修网点 "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            (_ctx.reciveExpress.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.reciveExpress.name) + "  " + _toDisplayString(_ctx.reciveExpress.phone), 1),
                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.reciveExpress.province) + _toDisplayString(_ctx.reciveExpress.area) + _toDisplayString(_ctx.reciveExpress.address), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_72, "未填写"))
          ])
        ]),
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", {
              class: "detail-repair-image",
              style: _normalizeStyle(
              _ctx.deviceMsg.eq_model_logo
                ? { 'background-image': `url(${_ctx.deviceMsg.eq_model_logo})` }
                : {}
            )
            }, null, 4),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.deviceMsg.eq_model_name), 1),
              _createElementVNode("div", _hoisted_78, "SN: " + _toDisplayString(_ctx.deviceMsg.serial_number), 1),
              _createElementVNode("div", _hoisted_79, "极加服务：" + _toDisplayString(_ctx.deviceMsg.xcare), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _hoisted_81,
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.deviceMsg.service_no), 1)
          ]),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.deviceMsg.created_at), 1)
          ]),
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _createElementVNode("span", {
              class: "net-item-value",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleCheckOrder && _ctx.handleCheckOrder(...args)))
            }, "查看"),
            _createVNode(_component_van_icon, {
              name: "arrow net-item-icon",
              size: "16"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(_component_van_popup, {
      "safe-area-inset-bottom": "",
      show: _ctx.eveluateData.showPopup,
      "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.eveluateData.showPopup) = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        (!_ctx.isEnd)
          ? (_openBlock(), _createElementBlock("header", _hoisted_90, [
              _createElementVNode("div", {
                class: "cancel",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleCancelEvaluate && _ctx.handleCancelEvaluate(...args)))
              }, "取消"),
              _createTextVNode(" 评价 "),
              _createElementVNode("div", {
                class: "submit",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleSubmitEvaluate && _ctx.handleSubmitEvaluate(...args)))
              }, "提交")
            ]))
          : (_openBlock(), _createBlock(_component_PopupHeader, {
              key: 1,
              onClose: _ctx.newEveluateCloseHeaderHandler,
              title: "查看评价",
              showClsoe: true
            }, null, 8, ["onClose"])),
        (_ctx.isEvaluate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createVNode(_component_van_rate, {
                  modelValue: _ctx.eveluateData.stars,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.eveluateData.stars) = $event)),
                  size: 24,
                  "allow-half": "",
                  color: "rgba(249, 195, 3, 1)",
                  "void-icon": "star",
                  "void-color": "rgba(229, 229, 229, 1)"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.eveluateData.describe,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.eveluateData.describe) = $event)),
                    modelModifiers: { trim: true },
                    rows: "6",
                    maxlength: "150",
                    "show-word-limit": "",
                    type: "textarea",
                    placeholder: "请描述服务体验"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]))
          : (_openBlock(), _createBlock(_component_ServiceOrderEvaluation, {
              key: 3,
              "is-end": _ctx.isEnd,
              newEveluateData: _ctx.newEveluateData,
              "onUpdate:newEveluateData": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newEveluateData) = $event))
            }, null, 8, ["is-end", "newEveluateData"]))
      ]),
      _: 1
    }, 8, ["show"])
  ], 4))
}